import React from 'react';
import AurTabMenu, {AurTab} from '../../../common/aur-tab-menu/AurTabMenu';
import {Link} from 'react-router-dom';

const TabMenu: React.FC = () => {
  const smallTabs: AurTab[] = [
    {
      header: {
        text: 'All Clients (157)',
      },
      content: (
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer non
          congue ipsum, ut euismod nulla. Sed sed lorem nec odio pharetra
          volutpat vel sit amet orci. Maecenas sit amet tristique eros. Maecenas
          sagittis augue ac condimentum malesuada. In rhoncus fermentum
          malesuada. Quisque scelerisque nibh ipsum, non dignissim augue euismod
          mattis. Quisque accumsan suscipit scelerisque. Phasellus et vehicula
          justo. Nulla dictum ex nec sem tristique eleifend. Etiam a leo
          ultricies, gravida nibh sit amet, dignissim odio. In hac habitasse
          platea dictumst. Donec lectus odio, aliquam a nulla a, ullamcorper
          luctus massa. Aliquam sem neque, consectetur sit amet sem nec, sodales
          feugiat lacus.
        </p>
      ),
      index: 0,
    },
    {
      header: {
        text: 'Active (102)',
      },
      content: (
        <>
          <p>
            Orci varius natoque penatibus et magnis dis parturient montes,
            nascetur ridiculus mus. Phasellus sodales eget neque sed luctus.
            Etiam justo magna, ultricies in volutpat in, finibus placerat mi. Ut
            ex diam, vehicula sit amet urna et, euismod sagittis erat. Praesent
            consectetur ipsum aliquet nisi semper pulvinar. Proin ut nisi
            accumsan, condimentum risus ac, dapibus nunc. Nulla ac laoreet enim,
            sit amet iaculis arcu. Nullam odio sapien, semper nec pharetra et,
            pretium varius tortor. Vestibulum ante ipsum primis in faucibus orci
            luctus et ultrices posuere cubilia curae; Donec ac pellentesque
            quam, id semper erat. Sed luctus leo nec purus ultrices, sed
            sollicitudin enim ornare. Pellentesque vitae pharetra neque.
          </p>
          <p>
            Mauris laoreet finibus felis, ut pharetra mauris sagittis sed. Lorem
            ipsum dolor sit amet, consectetur adipiscing elit. Ut non
            ullamcorper ex. Integer consectetur enim leo, eget tempor felis
            tincidunt eu. Aliquam dignissim turpis non mattis bibendum. Nulla
            non dui turpis. Praesent sed lacus mi. Duis sollicitudin orci non
            quam viverra, eu viverra erat mattis. Duis vehicula pharetra ex at
            maximus. Pellentesque id rutrum elit. Ut maximus turpis sit amet
            ullamcorper auctor. Donec mattis interdum massa, id maximus purus
            mattis vitae. Quisque laoreet sodales sem, at hendrerit velit
            commodo sed. Donec faucibus, est vitae euismod fringilla, enim enim
            imperdiet nunc, eget dictum felis neque in neque.
          </p>
        </>
      ),
      index: 1,
    },
    {
      header: {
        text: 'Inactive (55)',
      },
      content: (
        <>
          <p>
            Vivamus convallis hendrerit imperdiet. Sed vitae nunc efficitur,
            commodo leo vitae, blandit nisi. Cras vitae rhoncus eros. In finibus
            neque vel enim mollis vehicula. Nullam consequat pulvinar elit, sit
            amet vulputate neque tincidunt nec. Quisque pretium, odio ut
            tincidunt tristique, mauris nulla congue sem, a accumsan lorem lacus
            in libero. Maecenas vitae pretium nunc. Aenean sed accumsan velit.
            Sed eleifend condimentum faucibus. Nulla et hendrerit sem. Duis
            volutpat rhoncus ex, vitae mollis metus consequat vulputate. In
            efficitur cursus quam ac elementum. Nullam ultrices, turpis maximus
            vestibulum sollicitudin, justo urna placerat nisl, ut sollicitudin
            libero velit a nisi. Integer id mauris quis nunc lobortis finibus id
            a odio. In hac habitasse platea dictumst.
          </p>
          <p>
            Praesent nec erat quis metus dapibus blandit. Morbi in tristique
            justo, et porta lacus. Nullam venenatis vulputate tristique. Donec
            et tincidunt felis. Vivamus ultrices nisl vel lacus porttitor, at
            facilisis neque sagittis. Praesent at eros quis ipsum tincidunt
            condimentum. Donec vel tristique dui. Aenean lacinia placerat
            ligula, eget sagittis sapien elementum id. Vivamus iaculis arcu ut
            urna efficitur euismod. Quisque eget eros ornare, imperdiet augue
            eu, porta dui. Pellentesque aliquam vulputate ex, non varius nisi
            efficitur vel. Integer quis luctus dolor. Sed luctus posuere
            placerat. Fusce vel placerat diam
          </p>
          <p>
            Vestibulum metus urna, sollicitudin tincidunt sapien molestie,
            ultrices euismod ex. Nam nulla odio, venenatis sit amet nibh sit
            amet, feugiat porta nunc. Cras eu ultrices nibh. Etiam condimentum
            in ex sit amet lobortis. Proin turpis tellus, fringilla varius
            viverra cursus, imperdiet eget neque. Mauris eget mollis lacus.
            Vestibulum ante ipsum primis in faucibus orci luctus et ultrices
            posuere cubilia curae; Morbi nibh enim, feugiat vel auctor et,
            commodo non nisl. Sed molestie sagittis rhoncus. Nulla et elementum
            tortor. Maecenas mollis arcu sed nulla tempor pulvinar. Ut tristique
            leo sit amet magna scelerisque, eget tincidunt ligula eleifend.
            Vestibulum vitae elit quis augue lobortis efficitur. Phasellus
            sollicitudin massa in purus sollicitudin varius. Donec sagittis
            eleifend libero id congue
          </p>
        </>
      ),
      index: 2,
    },
  ];

  const largeTabs: AurTab[] = [
    {
      header: {
        text: '4',
        subText: 'Departments',
      },
      content: <div>Departments: 4. Looking Good!</div>,
      index: 0,
    },
    {
      header: {
        text: '15',
        subText: 'Project Groups',
      },
      content: <div>15 Project Groups. Wow!</div>,
      index: 1,
    },
    {
      header: {
        text: '120',
        subText: 'Projects',
      },
      content: <div>Over one hundred projects. Holy Cow!</div>,
      index: 2,
    },
  ];

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Tab Menu</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <h3>Small Tabs</h3>
          <AurTabMenu tabs={smallTabs} width={'100%'} />
        </div>
        <div>
          <h3>Large Tabs</h3>
          <AurTabMenu tabs={largeTabs} width={'100%'} large />
        </div>
      </div>
    </>
  );
};

export default TabMenu;
